import type { ProductMetric } from '@/api/admin'

export function formatMetricValue(metric: ProductMetric): string {
  switch (metric.unit) {
    case 'percent':
      return `${metric.value.toFixed(1)}%`
    case 'count':
      return Math.round(metric.value).toLocaleString()
    case 'duration':
      return formatDurationSeconds(metric.value)
    case 'currency':
      return `$${metric.value.toFixed(2)}`
    default:
      return metric.value.toFixed(1)
  }
}

function formatDurationSeconds(totalSeconds: number): string {
  const seconds = Math.max(0, Math.round(totalSeconds))
  const minutes = Math.floor(seconds / 60)
  const remainder = seconds % 60
  if (minutes === 0) {
    return `${remainder}s`
  }
  return `${minutes}m ${remainder.toString().padStart(2, '0')}s`
}
